import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './providers/AuthProvider';
import { QueueProvider } from './providers/QueueProvider';
import { LoginPage } from './pages/LoginPage';
import { QueuePage } from './pages/QueuePage';

// Create QueryClient with default options
// Best practice: Enable auto-recovery mechanisms for real-time apps
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 10 * 1000,       // 10s default stale time
      refetchOnWindowFocus: true, // Re-sync when user returns to tab
      refetchOnReconnect: true,   // Re-sync when network recovers
    },
  },
});

function AppContent() {
  const { isAuthenticated, isLoading, shop } = useAuth();

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-surface">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
          <p className="text-gray-400">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  // Show login if not authenticated
  if (!isAuthenticated || !shop) {
    return <LoginPage />;
  }

  // Show queue dashboard
  return (
    <QueueProvider shopId={shop.id}>
      <QueuePage shop={shop} />
    </QueueProvider>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </QueryClientProvider>
  );
}

// Export queryClient for use in WebSocket handler
export { queryClient };
